<ng-container *ngIf="(options.value !== null ? options.value : progressBarService.progress | async) as progress">
  <div class="corporate-progress-bar-container">
    <div class="corporate-progress-bar" [style.width]="progress + '%'">
      <div class="peg"></div>
    </div>
  </div>
</ng-container>